<template>
  <div class="bg-light-gray mb-2">
    <validation-observer ref="formModalObserver" novalidate tag="form">
      <div class="row">
        <div class="col-12 col-lg-4 col-md-12 col-sm-6 col-xs-12">
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <custom-drop-down
              :options="reasons"
              label="Razón:"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione una razón"
              class="w-100 mb-4 bold-label"
              custom-error-msg="Favor seleccione una razón"
              :error="errors[0]"
              v-model="model.reason"
            />
          </validation-provider>
        </div>
        <div class="col-12 col-lg-4 col-md-12 col-sm-6 col-xs-12">
          <div class="data-label mb-2">
            Documento de Justificación:
          </div>
          <validation-provider v-slot="{ errors }" mode="eager">
            <custom-file-input
              v-model="model.attachment"
              :accept="'.pdf'"
              :attachment-id="model.attachmentId"
              display-style="normal"
              :error="errors[0]"
              :on-download="downloadFile"
            />
          </validation-provider>
        </div>
        <div class="col-12">
          <validation-provider v-slot="{ errors }" rules="required">
            <div class="color-black font-14 my-1">
              Comentario de Solicitud:
            </div>
            <custom-text-area
              id="txtComment"
              v-model="model.comment"
              :count-classes="['d-block', 'small-counter', 'text-right']"
              custom-error-msg="Favor escriba un comentario"
              :error="errors[0]"
              :maxlength="3000"
              placeholder="Escribe un comentario"
              show-char-count
            />
          </validation-provider>
        </div>
      </div>
    </validation-observer>
    <div class="px-4 py-4 bg-white rounded mt-2">
      <div class="mb-3 font-weight-bold">
        <i class="fas fa-info-circle text-orange mr-2"></i>
        Seleccione Accesorios para el Equipo
      </div>
      <equipment-accessories
        ref="equipment-accessories"
        class="px-3"
        hide-buttons
        :equipment="equipment"
        :recommendation="recommendation"
        @onSelectAccessory="setAccessories"
      />
    </div>
    <div class="d-flex justify-content-end align-items-center mt-4">
      <action-button
        id="btnCancel"
        i="fas fa-times-circle"
        text="Cancelar"
        variant="outline-danger mr-3 px-3"
        @click="$emit('close')"
      />
      <action-button
        id="btnSave"
        i="fas fa-save"
        text="Guardar"
        variant="success px-3"
        @click="handlerAddTransferRequest"
      />
    </div>
  </div>
</template>

<script>
import CustomFileInput from 'CustomFileInput';
import CustomTextArea from '@quisit/custom-text-area';
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import referralAndEquipmentsservice from '@/services/api/referralsandequipments.api';
import reasonTypes from '@/utils/constants/reasonTypes';
import inventoryCatalogService from '@/services/api/inventorycatalog.api';
import { serialize as objectToFormData } from 'object-to-formdata';
import EquipmentAccessories from './EquipmentAccessories.vue';

export default {
  name: 'TransferRequest',
  components: {
    CustomFileInput,
    CustomTextArea,
    ActionButton,
    CustomDropDown,
    EquipmentAccessories,
  },
  mixins: [alertMixin],
  props: {
    equipment: {
      type: Object,
      required: true,
    },
    recommendation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      reasons: [],
      model: {
        reason: null,
        attachment: null,
        comment: null,
        attachmentId: null,
        unSelectedAccessories: [],
      },
    };
  },
  async mounted() {
    await this.getReasons();
  },
  methods: {
    downloadFile() {},
    async handlerAddTransferRequest() {
      const isvalid = await this.$refs.formModalObserver.validate();
      if (!isvalid) {
        this.ShowToast(
          'Alerta',
          'Por favor completa los campos requeridos.',
          'error'
        );
        return;
      }
      this.saveTransferRequest();
    },
    saveTransferRequest() {
      const payload = objectToFormData({
        reasonId: this.model.reason?.id,
        comment: this.model.comment,
        attachment: this.model.attachment,
        caatIdTo: this.recommendation?.referral?.caatId,
        recommendationId: this.recommendation?.id,
        unSelectedAccessories: this.model.unSelectedAccessories,
      });
      inventoryCatalogService
        .saveInventoryTransfer(this.equipment?.id, payload)
        .then(() => {
          this.ShowToast(
            'Éxito',
            'La solicitud se ha realizado exitosamente.',
            'success'
          );
          this.model = {
            reason: null,
            attachment: null,
            comment: null,
          };
          this.$emit('close');
        })
        .catch((error) => {
          this.ShowToast('Error', error?.response?.data.message, 'error');
        });
    },
    setAccessories(values) {
      this.model.unSelectedAccessories = values;
    },
    async getReasons() {
      const { data } = await referralAndEquipmentsservice.getReasonsByType(
        reasonTypes.Transfer
      );
      this.reasons = data;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .dot {
  padding: 19px !important;
}
</style>
